/**
 * Tag record category values
 */
export enum TagRecordCategoryEnum {
	SHARED = 'shared',

	ACCOUNT = 'account',

	USER = 'user',
	LOCATION = 'location',
	CUSTOMER = 'customer',
	SUPPLIER = 'supplier',
	AGENT = 'agent',

	VEHICLE = 'vehicle',
	VEHICLE_GROUP = 'vehicle_group',
	VEHICLE_DAMAGE = 'vehicle_damage',
	VEHICLE_INSURANCE = 'vehicle_insurance',
	VEHICLE_INSURANCE_CLAIM = 'vehicle_insurance_claim',
	VEHICLE_MAINTENANCE = 'vehicle_maintenance',
	VEHICLE_ROAD_TAX = 'vehicle_road_tax',
	VEHICLE_ROAD_WORTHY_CHECK = 'vehicle_road_worthy_check',
	RENTAL_AGREEMENT = 'rental_agreement',
	RENTAL_RESERVATION = 'rental_reservation',
	TRANSACTION = 'transaction',

	REPORT = 'report',
	REPORT_TEMPLATE = 'report_template',
}
